require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#3293DD',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        y1:'#FFA000',
        r1:'#66BB6A',
        b1:'#607D8B',
        header:'#FAFAFA',
      },
      dark: {
        primary: '#9155FD',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
